export class SelectPlanInfo {
  // public 変数 ------------------------------------------------------------------------
  public planCode:				string = null;    // プランコード
  public totalPremium:			number = 0;    // 合計保険料
  public addExtraCoverageFlg:	string = null;
  // ------------------------------------------------------------------------------------
}
